import React from 'react'
import Chip from '@mui/material/Chip'
import type { SxProps, Theme } from '@mui/material/styles'
import { GREY } from '~/shared/lib/theme'
import ProfileOutlineIcon from '~/assets/images/profile_outline.svg?react'
import { mergeSx } from '~/shared/lib/mergeSx'

type ProspectChipProps = {
  label?: string
  className?: string
  style?: React.CSSProperties
  sx?: SxProps<Theme>
  size?: 'small' | 'medium'
  iconSize?: number
  height?: number
  borderRadius?: number
}

const ProspectChip: React.FC<ProspectChipProps> = ({
  label = 'Prospect',
  className,
  style,
  sx,
  size = 'small',
  iconSize = 14,
  height = 24,
  borderRadius = 13,
}) => {
  const baseSx: SxProps<Theme> = (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    color: GREY[800],
    borderColor: GREY[400],
    fontSize: '13px',
    fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, "sans-serif"',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    height: `${height}px`,
    borderRadius: `${borderRadius}px`,
    '& .MuiChip-label': { paddingLeft: '2px', paddingRight: '10px' },
    '& .MuiChip-icon': { color: GREY[800], marginLeft: '6px', marginRight: '2px' },
  })

  const mergedSx = mergeSx(baseSx, sx)

  return (
    <Chip
      className={className}
      style={style}
      size={size}
      variant="outlined"
      label={label}
      icon={
        <ProfileOutlineIcon
          role="img"
          aria-label="Prospect user icon"
          focusable="false"
          style={{ width: iconSize, height: iconSize }}
        />
      }
      sx={mergedSx}
    />
  )
}
export default ProspectChip
